import React from 'react';

import './templatepreview.css';

/*
type: any|2 - type of style
*/
const TemplatePreview = ({template, onClick, type})=>{
  const templateName=template.template;

  const onClickWrapper=()=>{
    onClick(template);
  }

  let classes='background-default2';
  if(type===2) {
    classes='font-color2 template-preview-type2'
  }

  return (
    <div onClick={onClickWrapper} className={"template-preview "+classes}>
      <h2>{templateName}</h2>
    </div>
  )
}

export default TemplatePreview;